module.exports = __webpack_public_path__ + "img/diamonds-5.07935ad6.svg";